/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-07 11:17:27
 * @LastEditTime: 2019-07-24 14:33:29
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  我的预约管理接口Url
const AppointmentUrl = '/website/storage/appointment'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }, {}))
    }
  })
}

// 分页查询普通仓库需求列表
export function findPageAppointment(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + AppointmentUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findPageAppointment'
      }, param))
    }
  })
}
// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}
